import LegalLayout from "../components/LegalLayout";

const SECTION_TITLE = "font-serif text-2xl text-[#2C2A29] mt-10 mb-3";
const PARA = "text-[15px] leading-[1.7] text-[#3F3D3B]";

export default function Terms() {
  return (
    <LegalLayout title="Terms of Service" lastUpdated="February 2026">
      <p className={PARA}>
        Welcome to Guardian Grace Family &amp; Community Foundation. By accessing or
        using this website (guardiangrace.org), you agree to the following terms. Please
        read them carefully.
      </p>

      <h2 className={SECTION_TITLE}>1. Acceptance of Terms</h2>
      <p className={PARA}>
        Using this site means you agree to be bound by these Terms of Service and our
        Privacy Policy. If you do not agree, please discontinue use of the site.
      </p>

      <h2 className={SECTION_TITLE}>2. Our Mission</h2>
      <p className={PARA}>
        Guardian Grace Family &amp; Community Foundation is a registered 501(c)(3)
        nonprofit (EIN&nbsp;41-2776772) dedicated to strengthening families, empowering
        caregivers, supporting community wellness, and improving quality of life for
        veterans and vulnerable populations through compassion, advocacy, and service.
      </p>

      <h2 className={SECTION_TITLE}>3. Donations</h2>
      <p className={PARA}>
        Donations to Guardian Grace Family &amp; Community Foundation are voluntary,
        non-refundable, and processed securely through Stripe. By making a donation,
        you confirm that the funds and payment method are yours to give and are not
        the result of fraudulent activity.
      </p>
      <p className={PARA}>
        Donations are tax-deductible to the fullest extent allowed by law. A receipt
        will be sent to the email address you provided. Please consult your tax advisor
        regarding deductibility for your individual circumstances.
      </p>

      <h2 className={SECTION_TITLE}>4. Refund Policy</h2>
      <p className={PARA}>
        Charitable donations are generally non-refundable. However, if you believe a
        donation was made in error (duplicate, wrong amount, unauthorized transaction),
        please contact us within fourteen (14) days at{" "}
        <a href="mailto:info@guardiangrace.org" className="text-[#692128] underline-offset-4 hover:underline">
          info@guardiangrace.org
        </a>{" "}
        and we will review your request in good faith.
      </p>

      <h2 className={SECTION_TITLE}>5. Use of the Site</h2>
      <p className={PARA}>You agree not to:</p>
      <ul className="list-disc pl-6 space-y-2 text-[15px] leading-[1.7] text-[#3F3D3B]">
        <li>Use the site for any unlawful purpose or in violation of these terms.</li>
        <li>Attempt to gain unauthorized access to our servers, database, or accounts.</li>
        <li>Submit false, harassing, defamatory, or fraudulent information through any form.</li>
        <li>Interfere with the operation of the site or other users&rsquo; access.</li>
      </ul>

      <h2 className={SECTION_TITLE}>6. Intellectual Property</h2>
      <p className={PARA}>
        All content on this site — including the Guardian Grace name, logo, written
        copy, images, and design — is the property of Guardian Grace Family &amp;
        Community Foundation or its licensors and is protected by U.S. and
        international copyright and trademark law. You may share links to this site
        freely, but you may not reproduce, distribute, or create derivative works
        without our written permission.
      </p>

      <h2 className={SECTION_TITLE}>7. Third-Party Services</h2>
      <p className={PARA}>
        The site uses third-party services for payments, email delivery, and analytics
        (including Stripe and Resend). Your use of those services is also governed by
        their respective terms of service and privacy policies.
      </p>

      <h2 className={SECTION_TITLE}>8. Disclaimers</h2>
      <p className={PARA}>
        The site is provided &ldquo;as is&rdquo; without warranties of any kind, express
        or implied. While we work to keep all information accurate and current, we make
        no guarantees regarding completeness, reliability, or fitness for a particular
        purpose. We are not liable for any damages arising from your use of the site.
      </p>

      <h2 className={SECTION_TITLE}>9. Limitation of Liability</h2>
      <p className={PARA}>
        To the fullest extent permitted by law, Guardian Grace, its directors,
        officers, employees, volunteers, and partners shall not be liable for any
        indirect, incidental, consequential, or punitive damages arising from your
        use of, or inability to use, the site.
      </p>

      <h2 className={SECTION_TITLE}>10. Governing Law</h2>
      <p className={PARA}>
        These terms are governed by the laws of the State of Georgia, United States,
        without regard to conflict of law principles. Any disputes shall be resolved
        in the courts located in Rockdale County, Georgia.
      </p>

      <h2 className={SECTION_TITLE}>11. Changes to These Terms</h2>
      <p className={PARA}>
        We may update these terms from time to time. The &ldquo;Last updated&rdquo; date
        will reflect the latest revision. Continued use of the site after changes
        constitutes acceptance of the updated terms.
      </p>

      <h2 className={SECTION_TITLE}>12. Contact</h2>
      <p className={PARA}>
        Guardian Grace Family &amp; Community Foundation
        <br />
        1820 Highway 20 SE, Suite 114
        <br />
        Conyers, GA 30013
        <br />
        <a href="mailto:info@guardiangrace.org" className="text-[#692128] underline-offset-4 hover:underline">
          info@guardiangrace.org
        </a>
      </p>

      <p className="mt-12 text-xs text-[#5C5856] italic">
        These Terms of Service are provided as a starting template. Please have them reviewed by qualified legal counsel before relying on them in production.
      </p>
    </LegalLayout>
  );
}
